import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import Board from "@publicPortal/components/board/Board";
import SaveBookmark from "@publicPortal/components/customBookmark/SaveBookmark";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import { memo, useCallback, useMemo, useState } from "react";
import SaveSearchModal from "../SaveSearchModal";
import useAlertService from "@mirage/hooks/useAlertService";
import { UserService } from "@publicPortal/services/UserService";
import { IUser } from "@shared/mirage/core/contracts/IUser";
import SavedSearchService from "@publicPortal/services/SavedSearchService";
import { Filter, FilterItem } from "@shared/mirage/entityTable/Filter";
import { ISavedSearch } from "@shared/publicportal/contracts/ISavedSearch";
import _ from "lodash";
import BuildingRegulationsTable from "../components/BuildingRegulationsTable";

const BuildingRegulationsSearchResult = memo(() => {
    const user: Partial<IUser> = UserService.getLoggedInUser();
    const [searchName, setSearchName] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const showAlert = useAlertService();
    const handleOpenModal = useCallback(() => setOpenModal(true), []);
    const handleCloseModal = useCallback(() => {
        setSearchName("");
        setOpenModal(false);
    }, []);
    const sp = new URL(window.location.href).searchParams;
    const params = Array.from(sp);
    const filter = useMemo(() => {
        const filter = { parts: [] } as Filter;
        const filterItems: FilterItem[] = [];

        params.forEach(([key, value]) => {
            filterItems.push({ columnName: key, value, operator: "=" });
        });

        filter.parts.push({ filterItems: filterItems });
        return filter;
    }, [params]);
    const handleSaveSearch = useCallback(async () => {
        const saveSearchService = new SavedSearchService();
        const criteria = _.fromPairs(params);

        const SaveRequest: Omit<ISavedSearch, "userId"> = {
            name: searchName,
            criteria: criteria,
            searchType: "BuildingRegulations",
        };

        const result = await saveSearchService.createSavedSearch(SaveRequest);
        if (result.errorMsg) {
            showAlert(result.errorMsg, "error");
        } else {
            showAlert("Search saved successfully.", "success");
        }
    }, [params, searchName, showAlert]);

    return (
        <>
            <ResponsiveAppBar />
            <Board size="big" headerText="Building Regulations">
                <BackButton />
                <SaveSearchModal handleSaveSearch={handleSaveSearch} isOpen={openModal} onClose={handleCloseModal} searchName={searchName} setSearchName={setSearchName} />
                <SaveBookmark action={handleOpenModal} tooltipMessage="Save Search" userId={user?.id} />
                <BuildingRegulationsTable filter={filter} />
            </Board>
        </>
    );
});

export default BuildingRegulationsSearchResult;
